
import { AgentList } from "./agents/AgentList";

export const AgentManagement = () => {
  return (
    <div className="px-6 space-y-6">
      <AgentList />
    </div>
  );
};
